import React from "react";
import autobind from "class-autobind";
import {FormGroup} from "../group/index";
import DayPicker from "react-day-picker";
import {Modal} from "../../layout/modal/index";
import {ModalContent} from "../../layout/modal/content";
import {Input} from "../input/index";
import {InputBox} from "../input.box/index";
import moment from "moment-timezone";

export interface Props {
  timezone: string;
  formats: RestaurantSchema["settings"]["region"]["formats"];
  start: number;
  end: number;
  onSelect: (type: "start" | "end", timestamp: number) => void;
}

interface State {
  modal: "start" | "end" | "";
}

export class DateRangePicker extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    autobind(this);
    this.state = {
      modal: "",
    };
  }

  onSelect(date: Date) {
    const { onSelect } = this.props;
    const { modal } = this.state;
    if (modal === "") return;
    onSelect(modal, date.getTime());
    this.setState({ modal: "" });
  }

  render() {
    if (!this.state) return;
    const { start, end, formats, timezone } = this.props;
    const { modal } = this.state;

    const value = new Date(modal === "start" ? start : end);

    return (
      <div>

        <div className="flex-line" style={{ alignItems: "flex-end" }}>
          <FormGroup
            className="m-b-0"
            no_border={true}>
            <Input
              type="text"
              value={start ? moment.tz(start, timezone).format(formats.date) : ""}
              placeholder="Click to select"
              className="no-round width200"
              onClick={() => this.setState({ modal: "start" })}
              readOnly={true}
              required={true}
            />
          </FormGroup>

          <InputBox className="no-round width48 text-center">
            <p className="font-semi-bold" style={{ lineHeight: "36px" }}>To</p>
          </InputBox>

          <FormGroup
            className="m-b-0"
            no_border={true}>
            <Input
              type="text"
              value={end ? moment.tz(end, timezone).format(formats.date) : ""}
              placeholder="Click to select"
              className="no-round width200"
              onClick={() => this.setState({ modal: "end" })}
              readOnly={true}
              required={true}
            />
          </FormGroup>

        </div>

        <Modal
          active={!!modal}
          width={265}
          closeButton={false}
          close={() => this.setState({ modal: "" })}>
          {(!!modal) && (
            <ModalContent style={{minHeight: "283px"}}>
              <FormGroup contentClassName="flex-center" className="p-b-0">
                <DayPicker
                  selectedDays={value}
                  onDayClick={this.onSelect}
                />
              </FormGroup>
            </ModalContent>
          )}
        </Modal>

      </div>
    );

  }

}
